import { Branch } from "../feature/branch/branch";
import { Customer } from "../feature/customer/customer";
import { User } from "../feature/user/user";

export const USE_STUB_DATA = false;

export const STUB_BRANCHES: Branch[] = [
  {
    id: "1",
    name: "Nashik Branch",
    code: "NSK001",
    address: "Plot No. 123, MIDC Satpur",
    city: "Nashik",
    state: "Maharashtra",
    zipCode: "422010",
    phone: "0253-2382111",
    email: "nashik@infinite.com",
    status: true,
    managerName: "Arun Pawar",
    managerPhone: "32432434",
    managerEmail: "aarun.pawar@gmail.com",
    workingHours: {
      start: "09:00",
      end: "18:00",
    },
    createdAt: "2024-01-01T00:00:00.000Z",
    updatedAt: "2024-01-01T00:00:00.000Z",
  },
  {
    id: "2",
    name: "Jalgaon Branch",
    code: "JLG001",
    address: "15, MIDC Area, Ajanta Road",
    city: "Jalgaon",
    state: "Maharashtra",
    zipCode: "425003",
    phone: "0257-2272111",
    email: "jalgaon@infinite.com",
    status: true,
    managerName: "Priya Deshmukh",
    managerPhone: "9898765432",
    managerEmail: "priya.deshmukh@infinite.com",
    workingHours: {
      start: "09:00",
      end: "18:00",
    },
    createdAt: "2024-01-02T00:00:00.000Z",
    updatedAt: "2024-01-02T00:00:00.000Z",
  },
];

export const STUB_USERS: User[] = [
  {
    id: "0",
    username: "superadmin",
    email: "superadmin@mawsoftwares.in",
    firstName: "Super",
    lastName: "Admin",
    role: "super_admin",
    userType: "admin",
    status: true,
    phone: "+91 98765 43210",
    branchId: "1",
    lastLogin: "2024-03-15T10:30:00.000Z",
    createdAt: "2024-01-01T00:00:00.000Z",
    updatedAt: "2024-01-01T00:00:00.000Z",
  },
  {
    id: "1",
    username: "admin",
    email: "admin@infinite.com",
    firstName: "Rajesh",
    lastName: "Varma",
    role: "admin",
    userType: "regular",
    status: true,
    phone: "+91 98765 43210",
    branchId: "1",
    lastLogin: "2024-03-15T10:30:00.000Z",
    createdAt: "2024-01-01T00:00:00.000Z",
    updatedAt: "2024-01-01T00:00:00.000Z",
  },
  {
    id: "2",
    username: "rajesh.kumar",
    email: "rajesh.kumar@infinite.com",
    firstName: "Rajesh",
    lastName: "Kumar",
    role: "branch_admin",
    userType: "supervisor",
    status: true,
    phone: "+91 98765 43210",
    branchId: "1",
    lastLogin: "2024-03-14T16:45:00.000Z",
    createdAt: "2024-01-01T00:00:00.000Z",
    updatedAt: "2024-01-01T00:00:00.000Z",
  },
  {
    id: "3",
    username: "priya.singh",
    email: "priya.singh@infinite.com",
    firstName: "Priya",
    lastName: "Singh",
    role: "branch_admin",
    userType: "supervisor",
    status: true,
    phone: "+91 87654 32109",
    branchId: "2",
    lastLogin: "2024-03-15T09:15:00.000Z",
    createdAt: "2024-01-02T00:00:00.000Z",
    updatedAt: "2024-01-02T00:00:00.000Z",
  },
  {
    id: "4",
    username: "amit.patel",
    email: "amit.patel@infinite.com",
    firstName: "Amit",
    lastName: "Patel",
    role: "branch_admin",
    userType: "supervisor",
    status: false,
    phone: "+91 76543 21098",
    branchId: "3",
    lastLogin: "2024-03-10T14:20:00.000Z",
    createdAt: "2024-01-03T00:00:00.000Z",
    updatedAt: "2024-01-03T00:00:00.000Z",
  },
  {
    id: "5",
    username: "deepak.sharma",
    email: "deepak.sharma@infinite.com",
    firstName: "Deepak",
    lastName: "Sharma",
    role: "sales",
    userType: "regular",
    status: true,
    phone: "+91 89012 34567",
    branchId: "1",
    lastLogin: "2024-03-15T11:30:00.000Z",
    createdAt: "2024-01-04T00:00:00.000Z",
    updatedAt: "2024-01-04T00:00:00.000Z",
  },
  {
    id: "6",
    username: "neha.gupta",
    email: "neha.gupta@infinite.com",
    firstName: "Neha",
    lastName: "Gupta",
    role: "supervisor",
    userType: "supervisor",
    status: true,
    phone: "+91 90123 45678",
    branchId: "2",
    lastLogin: "2024-03-15T10:45:00.000Z",
    createdAt: "2024-01-05T00:00:00.000Z",
    updatedAt: "2024-01-05T00:00:00.000Z",
  },
  {
    id: "7",
    username: "rahul.verma",
    email: "rahul.verma@infinite.com",
    firstName: "Rahul",
    lastName: "Verma",
    role: "worker",
    userType: "operator",
    status: true,
    phone: "+91 78901 23456",
    branchId: "3",
    lastLogin: "2024-03-15T09:00:00.000Z",
    createdAt: "2024-01-06T00:00:00.000Z",
    updatedAt: "2024-01-06T00:00:00.000Z",
  },
];

// Stub Customers for Order Form
export const STUB_CUSTOMERS = [
  {
    id: "CUST001",
    code: "C001",
    name: "John Smith",
    contactPerson: "John Smith",
    phone: "+91 98765 43210",
    email: "john@example.com",
    address: "123 Main Street",
    city: "Mumbai",
    state: "Maharashtra",
    zipCode: "400001",
    contactPhone: "+91 98765 43210",
    contactEmail: "john@example.com",
    status: true,
    branchId: "1",
    createdAt: "2024-01-01T00:00:00.000Z",
    updatedAt: "2024-01-01T00:00:00.000Z",
    type: "individual",
  },
  {
    id: "CUST002",
    code: "C002",
    name: "Sarah Johnson",
    contactPerson: "Sarah Johnson",
    phone: "+91 98765 43211",
    email: "sarah@example.com",
    address: "456 Park Avenue",
    city: "Delhi",
    state: "Delhi",
    zipCode: "110001",
    contactPhone: "+91 98765 43211",
    contactEmail: "sarah@example.com",
    status: true,
    branchId: "1",
    createdAt: "2024-01-02T00:00:00.000Z",
    updatedAt: "2024-01-02T00:00:00.000Z",
    type: "business",
  },
];

// Stub Orders with realistic manufacturing data
export const STUB_ORDERS = [
  {
    id: "ORD001",
    customerId: "CUST001",
    customer: STUB_CUSTOMERS[0],
    totalAmount: "25000",
    dueDate: "2024-04-15",
    notes: "Priority order for main bedroom",
    priority: "high" as const,
    paymentStatus: "partial" as const,
    status: "in_progress" as const,
    progressPercentage: 45,
    totalItems: 8,
    completedItems: 4,
    products: [
      {
        id: "PROD001",
        type: "window" as const,
        items: [
          {
            id: "ITEM001",
            type: "Leaf",
            width: "1200",
            height: "1500",
          },
          {
            id: "ITEM002",
            type: "Panel Window",
            width: "580",
            height: "1480",
          },
          {
            id: "ITEM003",
            type: "Net Fixing",
            width: "1180",
            height: "1480",
          },
        ],
      },
      {
        id: "PROD002",
        type: "door" as const,
        items: [
          {
            id: "ITEM004",
            type: "Leaf",
            width: "900",
            height: "2100",
          },
          {
            id: "ITEM005",
            type: "Panel Window",
            width: "880",
            height: "2080",
          },
        ],
      },
    ],
    createdAt: new Date("2024-03-01"),
    updatedAt: new Date("2024-03-07"),
  },
  {
    id: "ORD002",
    customerId: "CUST002",
    customer: STUB_CUSTOMERS[1],
    totalAmount: "35000",
    dueDate: "2024-04-20",
    notes: "Complete house renovation project",
    priority: "medium" as const,
    paymentStatus: "pending" as const,
    status: "pending" as const,
    progressPercentage: 0,
    totalItems: 6,
    completedItems: 0,
    products: [
      {
        id: "PROD003",
        type: "ventilator" as const,
        items: [
          {
            id: "ITEM006",
            type: "Leaf",
            width: "600",
            height: "400",
          },
        ],
      },
      {
        id: "PROD004",
        type: "window" as const,
        items: [
          {
            id: "ITEM007",
            type: "Leaf",
            width: "1800",
            height: "1500",
          },
          {
            id: "ITEM008",
            type: "Panel Window",
            width: "880",
            height: "1480",
          },
          {
            id: "ITEM009",
            type: "Net Fixing",
            width: "1780",
            height: "1480",
          },
        ],
      },
    ],
    createdAt: new Date("2024-03-05"),
    updatedAt: new Date("2024-03-05"),
  },
];

// Manufacturing stages configuration
export const MANUFACTURING_STAGES = [
  "cutting",
  "welding",
  "assembly",
  "finishing",
  "quality_check",
  "dispatch",
] as const;

// Product type configurations - REMOVED: Now using dynamic set types from product_masters table via config/setTypes.ts

// Location options
export const LOCATIONS = [
  "Living Room",
  "Bedroom",
  "Kitchen",
  "Bathroom",
  "Dining Room",
  "Office",
  "Balcony",
  "Hall",
  "Other",
] as const;

// Window net types
export const WINDOW_NET_TYPES = ["Fixed", "Sliding", "Openable"] as const;

// Component colors for UI
export const COMPONENT_COLORS = {
  leaf: { main: "#2E7D32", light: "#4CAF50" },
  panel: { main: "#1976D2", light: "#2196F3" },
  frame: { main: "#5E35B1", light: "#7C4DFF" },
  glass: { main: "#0097A7", light: "#00BCD4" },
  mesh: { main: "#F57C00", light: "#FF9800" },
  "net fixing": { main: "#F57C00", light: "#FF9800" },
} as const;
